export default __webpack_public_path__ + "static/media/youtube-icon-dark.f0ac8c4b.png";